import { render, staticRenderFns } from "./AtividadesPrincipais.vue?vue&type=template&id=bb4209ac&scoped=true"
import script from "./AtividadesPrincipais.vue?vue&type=script&lang=js"
export * from "./AtividadesPrincipais.vue?vue&type=script&lang=js"
import style0 from "./AtividadesPrincipais.vue?vue&type=style&index=0&id=bb4209ac&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb4209ac",
  null
  
)

export default component.exports